var Acr = Acr || {};

Acr.Location = function () {

  var utility = window.Utility;

  var formVisible = false;
  var zipcodeUpdateEvent;
  var zipcodeValue;

  var $element;
  var $locationButton;
  var $locationForm;
  var $locationFormInput;
  var $locationFormButton;
  var $locationPlaceholder;
  var $locationZipcode;
  var $locationError;

  const locationButton = '.js-location-button';
  const locationForm = '.js-location-form';
  const locationFormInput = '.js-location-form-input';
  const locationFormButton = '.js-location-form-button';
  const locationPlaceholder = '.js-location-placeholder';
  const locationZipcode = '.js-location-zipcode';
  const locationError = '.js-location-error';
  const locationFormError = 'acr-location__form--error';
  const currentClass = 'acr-location__button--current';


  function validateZipCode() {
    var $this = $(this);
    var inputValue = $this.val();
    var antiRegex = new RegExp(/[^0-9]+/g);
    var validZipcode = new RegExp(/^\d{5}$/);

    $locationError.hide();
    $locationForm.removeClass(locationFormError);
    $this.val(inputValue.replace(antiRegex, ''));
    if (inputValue.match(validZipcode)) {
      $locationFormButton.prop('disabled', false);
      zipcodeValue = inputValue;
    } else {
      $locationFormButton.prop('disabled', true);
      zipcodeValue = false;
    }
  }

  function setZipcode(zipcode) {
    if (zipcode) {
      $locationPlaceholder.hide();
      $locationZipcode.show();
      $locationZipcode.text(getLocationZipcodeText(zipcode));
    }
  }

  function getLocationZipcodeText(zipcode) {
    var locationZipcodeText = $locationZipcode.text().split(':');
    locationZipcodeText[1] = zipcode;
    return locationZipcodeText.join(': ');
  }

  function setEventZipcode(event) {
    if (event.detail && event.detail.zipcode) {
      setZipcode(event.detail.zipcode);
    }
  }

  function showZipcodeError() {
    $locationForm.addClass(locationFormError);
    $locationError.show();
  }

  function validZipcodeSubmit() {
    $locationButton.removeClass(currentClass);
    $locationForm.slideUp();
    formVisible = false;
    zipcodeUpdateEvent = utility.createEvent('zipcodeUpdate', { zipcode: zipcodeValue });
    utility.setCookie('zipcode', zipcodeValue);
    window.dispatchEvent(zipcodeUpdateEvent);
  }

  function submitZipcode(event) {
    event.preventDefault();
    Utility.validateZipcode(zipcodeValue, validZipcodeSubmit, showZipcodeError);
  }

  function openZipgate() {
    Acr.zipgateComponent.openZipgate();
    $locationButton.removeClass(currentClass);
    $locationForm.slideUp();
    $locationFormInput.val('');
    $locationPlaceholder.hide();
    $locationZipcode.show();
    formVisible = false;
  }

  function showForm() {
    $locationButton.addClass(currentClass);
    $locationForm.slideDown();
    $locationPlaceholder.show();
    $locationZipcode.hide();
    formVisible = true;
  }

  function buttonActions() {
    if (!formVisible) {
      showForm();
    } else {
      openZipgate();
    }
  }

  function initZipcode() {
    zipcodeValue = utility.getCookie('zipcode');
    if (zipcodeValue) {
      setZipcode(zipcodeValue);
    }
  }

  function initSelectors(element) {
    $element = $(element);
    $locationButton = $element.find(locationButton);
    $locationForm = $element.find(locationForm);
    $locationFormInput = $element.find(locationFormInput);
    $locationFormButton = $element.find(locationFormButton);
    $locationPlaceholder = $element.find(locationPlaceholder);
    $locationZipcode = $element.find(locationZipcode);
    $locationError = $element.find(locationError);
  }

  function bindEvents() {
    $locationButton.click(buttonActions);
    $locationFormButton.click(submitZipcode);
    $locationFormInput.on('input', validateZipCode);
    window.addEventListener('zipcodeUpdate', setEventZipcode);
  }

  function init(element) {
    initSelectors(element);
    bindEvents();
    initZipcode();
  }

  return {
    init: init,
  };
};
